/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
  mdiDesktopMac,
  mdiDatabase
  // mdiOfficeBuilding,
  // mdiAccountConvert,
  // mdiAccountTie,
  // mdiAccountAlert,
  // mdiAccountArrowLeft,
  // mdiAccountArrowRight
} from '@mdi/js'

export default [
  'General',
  [
    {
      to: '/home-hrd',
      icon: mdiDesktopMac,
      label: 'Dashboard'
    }
  ],
  'Examples',
  [
    {
      label: 'Master',
      subLabel: 'Submenus Master',
      icon: mdiDatabase,
      menu: [
        // {
        //   to: '/position',
        //   label: 'Position',
        //   icon: mdiAccountTie,
        //   updateMark: true
        // },
        // {
        //   to: '/workunit',
        //   label: 'Work Unit',
        //   icon: mdiOfficeBuilding,
        //   updateMark: true
        // },
        // {
        //   to: '/shift',
        //   label: 'Shift',
        //   icon: mdiAccountConvert,
        //   updateMark: true
        // },
        // {
        //   to: '/leave',
        //   label: 'Leave',
        //   icon: mdiAccountArrowRight
        // },
        {
          to: '/period',
          label: 'sidebarFin.period',
          icon: mdiDatabase
        },
        {
          to: '/instrument',
          label: 'sidebarFin.instrument',
          icon: mdiDatabase
        },
        {
          to: '/options',
          label: 'sidebarFin.options',
          icon: mdiDatabase
        },
        {
          to: '/optionsdetail',
          label: 'sidebarFin.optionsDetail',
          icon: mdiDatabase
        },
        {
          to: '/reviewercomposition',
          label: 'sidebarFin.reviewercomposition',
          icon: mdiDatabase
        },
        {
          to: '/indicator',
          label: 'sidebarFin.indicator',
          icon: mdiDatabase
        },
        {
          to: '/indicatortarget',
          label: 'sidebarFin.indicatortarget',
          icon: mdiDatabase
        }
      ]
	  }
    /*
    {
		  label: 'Presence Report',
		  subLabel: 'Submenus Presence',
		  icon: mdiAccountArrowLeft,
		  menu: [
			  {
				  to: '/reportpresencedailyemployee',
				  label: 'Daily Presence Report Employee',
				  icon: mdiAccountAlert
			  }
      ]
    },
    {
      label: 'Leave',
      subLabel: 'Submenus Leave',
      icon: mdiAccountArrowRight,
      menu: [
        {
          to: '/reqleave',
          label: 'Request Leave',
          icon: mdiAccountTie
        }
      ]
	  }
    */
  ]
]
